import { Component, Input } from '@angular/core';
import { Team, Set } from 'src/app/_interfaces';
import { PlayerPhotoComponent } from './player-photo/player-photo.component';
import { MatIcon } from '@angular/material/icon';
import { ShortNamePipe } from '../../../_pipes/short-name/short-name.pipe';

@Component({
    selector: 'app-match-team',
    templateUrl: './match-team.component.html',
    styleUrls: ['./match-team.component.scss'],
    imports: [PlayerPhotoComponent, MatIcon, ShortNamePipe]
})
export class MatchTeamComponent {
    private readonly servingStatuses = new Set(['playing', 'suspended']);

    @Input() team!: Team;
    @Input() opponent_set: Set[] = [];
    @Input() match_status!: string;
    @Input() faceoff_scores: boolean = false;

    constructor() { }

    get teamSuffixSeed() {
        if (this.faceoff_scores) {
            return ' - '
        }
        return this.team.player1.suffix ? this.team.player1.suffix : (this.team.player1.seed ? this.team.player1.seed : ' - ')
    }

    get checkMatchStatusForPointDisplay(): boolean {
        if (this.match_status === 'playing') {
            return true;
        }
        return false;
    }

    checkStatus(winner: boolean = false) {
        if (winner) {
            return this.team.is_winner ? true : false;
        } else {
            return !this.team.is_winner && this.team.is_serving && this.servingStatuses.has((this.match_status || '').toLowerCase()) ? true : false;
        }

    }

}
